// import CommentForm from './comment_form'
// import Likes from './likes'
import classNames from 'classnames'
import { useState, useEffect, useRef } from 'react'
// import { usePrevious } from '../shared_functions'
// import Tooltip from '../tooltip'

function InvoiceMessagesInfo({ ids, apiUrl, type = 'invoice' }) {
  const [loading, setLoading] = useState(true)
  const [recipients, setRecipients] = useState([])

  useEffect(() => {
    fetchData()
  }, [])

  const fetchData = () => {
    let url = `${apiUrl}/invoice_messages_info`
    if (type == 'contract') {
      url = `${apiUrl}/contract_messages_info`
    }
    jQuery.ajax({
      method: 'GET',
      dataType: 'json',
      url: url,
      data: {},
      beforeSend: () => {
        setLoading(true)
      },
      success: (response) => {
        setRecipients(response.recipients)
        setLoading(false)
      },
      complete: () => {},
      error: (data) => {}
    })
  }

  if (loading) {
    return <div className="progress-spinner-icon small"></div>
  }

  if (recipients.length === 0) {
    return <>{I18n.t('sending')}</>
  }

  return (
    <div className="email-statuses">
      {recipients.map((recipient) => (
        <div key={`${recipient.id}-${recipient.email}`} className="email-status">
          <div className={classNames('circle', recipient.status_class)}></div>
          <div className="datetime">{moment(recipient.created_at).format('LLL')}</div>
          <div className="email">{recipient.email}</div>
        </div>
      ))}
    </div>
  )
}

export default InvoiceMessagesInfo
